import { graphql } from '../../../shared/graphql';
import { SaveStripeSubscriptionInput } from '../../../shared/graphql/graphql';
import execute from '../../../shared/helpers/functions/api';

export const saveStripeSubscription = (input: SaveStripeSubscriptionInput) => {
  const query = graphql(`
    mutation SaveStripeSubscription($input: SaveStripeSubscriptionInput!) {
      saveStripeSubscription(input: $input) {
        subscriptionId
        clientSecret
        amount
        startDate
        endDate
        subscriptionItems {
          priceId
          quantity
          tiers {
            unitAmount
            upTo
          }
          tiersMode
          unitAmount
        }
      }
    }
  `);

  return execute({ query, variables: { input } });
};
